import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type CustomProductsParameter = {
    localId: string;
    parentProductId: string;
    includeProductId: string;
    productName: string;
    qtyOrdered: number;
    isCustomProduct: boolean;
    unitPrice: number;
    weight: number;
    length: number;
    g1: number;
    g2: number;
    daysToShip: string;
};

type HandlerType = Handler<CustomProductsParameter>;

const DispatchChangeClipboardCustomIncludeItem: HandlerType = props => {
    props.dispatch({
        type: "Widgets/Clipboard/SetCustomIncludeItem",
        parameter: {
            localId: props.parameter.localId,
            parentProductId: props.parameter.parentProductId,
            includeProductId: props.parameter.includeProductId,
            productName: props.parameter.productName,
            qtyOrdered: props.parameter.qtyOrdered,
            isCustomProduct: props.parameter.isCustomProduct,
            unitPrice: props.parameter.unitPrice,
            weight: props.parameter.weight,
            length: props.parameter.length,
            g1: props.parameter.g1,
            g2: props.parameter.g2,
            daysToShip: props.parameter.daysToShip,
        },
    });
};

const chain = [DispatchChangeClipboardCustomIncludeItem];

const changeClipboardCustomIncludeItem = createHandlerChainRunner(chain, "ChangeClipboardCustomIncludeItem");
export default changeClipboardCustomIncludeItem;
